import { ref } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import internalApi from "@/internalApi.js";

export function useUserProfile() {
    const store = useStore();
    const { locale } = useI18n();
    const isProcessing = ref(false);
    const error = ref(null);

    const fetchUserProfile = async () => {
        isProcessing.value = true;
        error.value = null;

        try {
            const response = await internalApi.get('/api/user/profile');
            const userData = response.data.data;

            // Apply locale from user profile
            if (userData.locale) {
                locale.value = userData.locale;
                localStorage.setItem('locale', userData.locale);
            }

            // Update store if needed
            if (store.state.auth) {
                store.commit('auth/SET_USER', userData);
            }

            return userData;
        } catch (err) {
            error.value = err?.message || 'Failed to fetch profile';
            console.error('Error fetching user profile:', err);
            throw err;
        } finally {
            isProcessing.value = false;
        }
    };

    const updateUserLocale = async (newLocale) => {
        isProcessing.value = true;
        error.value = null;

        try {
            const response = await internalApi.put('/api/user/locale', {
                locale: newLocale
            });

            // Update i18n locale
            locale.value = newLocale;
            localStorage.setItem('locale', newLocale);

            return response.data;
        } catch (err) {
            error.value = err?.message || 'Failed to update locale';
            console.error('Error updating locale:', err);
            throw err;
        } finally {
            isProcessing.value = false;
        }
    };

    return {
        fetchUserProfile,
        updateUserLocale,
        isProcessing,
        error
    };
}